export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "UU",
		doublesTier: "DOU",
	},
	venusaurmega: {
		randomBattleMoves: ["earthquake", "leechseed", "megadrain", "sleeppowder", "sludgebomb"],
		tier: "OU",
		doublesTier: "DOU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "UU",
		doublesTier: "DOU",
	},
	charizardmegax: {
		randomBattleMoves: ["earthquake", "flareblitz", "outrage", "roost", "willowisp"],
		tier: "OU",
		doublesTier: "DOU",
	},
	charizardmegay: {
		randomBattleMoves: ["airslash", "dragonpulse", "fireblast", "flamethrower", "roost"],
		tier: "UU",
		doublesTier: "DOU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "UU",
		doublesTier: "DOU",
	},
	blastoisemega: {
		randomBattleMoves: ["darkpulse", "hydropump", "icebeam", "scald", "toxic"],
		tier: "OU",
		doublesTier: "DOU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		randomBattleMoves: ["airslash", "bugbuzz", "quiverdance", "sleeppowder"],
		tier: "UU",
		doublesTier: "DOU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "UU",
		doublesTier: "DOU",
	},
	beedrillmega: {
		randomBattleMoves: ["brickbreak", "drillrun", "poisonjab", "uturn", "xscissor"],
		tier: "OU",
		doublesTier: "DOU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "UU",
		doublesTier: "DOU",
	},
	pidgeotmega: {
		randomBattleMoves: ["airslash", "heatwave", "roost", "toxic", "uturn"],
		tier: "UU",
		doublesTier: "DOU",
	},
	rattata: {
		tier: "LC",
	},
	rattataalola: {
		tier: "LC",
	},
	raticate: {
		randomBattleMoves: ["crunch", "doubleedge", "irontail", "suckerpunch", "swordsdance"],
		tier: "UU",
		doublesTier: "DOU",
	},
	raticatealola: {
		randomBattleMoves: ["crunch", "doubleedge", "suckerpunch", "swordsdance", "uturn"],
		tier: "UU",
		doublesTier: "DOU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		randomBattleMoves: ["drillpeck", "drillrun", "quickattack", "roost", "uturn"],
		tier: "UU",
		doublesTier: "DOU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		randomBattleMoves: ["crunch", "earthquake", "glare", "poisonjab", "suckerpunch"],
		tier: "UU",
		doublesTier: "DOU",
	},
	pikachu: {
		tier: "LC",
	},
	pikachustarter: {
		randomBattleMoves: ["calmmind", "splishysplash", "substitute", "thunderbolt", "zippyzap"],
		isNonstandard: null,
		tier: "UU",
		doublesTier: "DOU",
	},
	raichu: {
		randomBattleMoves: ["brickbreak", "fakeout", "irontail", "substitute", "thunderbolt"],
		tier: "UU",
		doublesTier: "DOU",
	},
	raichualola: {
		randomBattleMoves: ["calmmind", "encore", "psychic", "substitute", "thunderbolt"],
		tier: "UU",
		doublesTier: "DOU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandshrewalola: {
		tier: "LC",
	},
	sandslash: {
		randomBattleMoves: ["earthquake", "rockslide", "stealthrock", "swordsdance", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	sandslashalola: {
		randomBattleMoves: ["earthquake", "icepunch", "iceshard", "irontail", "stealthrock", "swordsdance"],
		tier: "UU",
		doublesTier: "DOU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		randomBattleMoves: ["dragontail", "earthquake", "icebeam", "poisonjab", "stealthrock"],
		tier: "OU",
		doublesTier: "DOU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		randomBattleMoves: ["earthquake", "icepunch", "megahorn", "poisonjab", "stealthrock"],
		tier: "OU",
		doublesTier: "DOU",
	},
	clefairy: {
		tier: "LC",
	},
	clefable: {
		randomBattleMoves: ["calmmind", "flamethrower", "icebeam", "moonblast", "stealthrock", "thunderwave"],
		tier: "UU",
		doublesTier: "DOU",
	},
	vulpix: {
		tier: "LC",
	},
	vulpixalola: {
		tier: "LC",
	},
	ninetales: {
		randomBattleMoves: ["darkpulse", "fireblast", "flamethrower", "nastyplot", "willowisp"],
		tier: "UU",
		doublesTier: "DOU",
	},
	ninetalesalola: {
		randomBattleMoves: ["darkpulse", "dazzlinggleam", "icebeam", "nastyplot", "substitute"],
		tier: "UU",
		doublesTier: "DOU",
	},
	jigglypuff: {
		tier: "LC",
	},
	wigglytuff: {
		randomBattleMoves: ["bodyslam", "dazzlinggleam", "fireblast", "icebeam", "stealthrock"],
		tier: "UU",
		doublesTier: "DOU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		randomBattleMoves: ["airslash", "roost", "sludgebomb", "taunt", "toxic", "uturn", "whirlwind"],
		tier: "UU",
		doublesTier: "DOU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		randomBattleMoves: ["megadrain", "moonblast", "sleeppowder", "sludgebomb", "stunspore"],
		tier: "UU",
		doublesTier: "DOU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		randomBattleMoves: ["brickbreak", "leechlife", "leechseed", "spore", "substitute"],
		tier: "UU",
		doublesTier: "DOU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		randomBattleMoves: ["bugbuzz", "psychic", "quiverdance", "sleeppowder", "sludgebomb"],
		tier: "UUBL",
		doublesTier: "DOU",
	},
	diglett: {
		tier: "LC",
	},
	diglettalola: {
		tier: "LC",
	},
	dugtrio: {
		randomBattleMoves: ["earthquake", "rockslide", "stealthrock", "suckerpunch", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	dugtrioalola: {
		randomBattleMoves: ["earthquake", "rockslide", "stealthrock", "suckerpunch", "toxic"],
		tier: "OU",
		doublesTier: "DOU",
	},
	meowth: {
		tier: "LC",
	},
	meowthalola: {
		tier: "LC",
	},
	persian: {
		randomBattleMoves: ["fakeout", "headbutt", "playrough", "taunt", "uturn"],
		tier: "UU",
		doublesTier: "DOU",
	},
	persianalola: {
		randomBattleMoves: ["darkpulse", "nastyplot", "taunt", "thunderbolt", "uturn"],
		tier: "OU",
		doublesTier: "DOU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		randomBattleMoves: ["calmmind", "hydropump", "icebeam", "psychic", "scald"],
		tier: "UU",
		doublesTier: "DOU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		randomBattleMoves: ["brickbreak", "bulkup", "earthquake", "rockslide", "uturn"],
		tier: "UU",
		doublesTier: "DOU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		randomBattleMoves: ["crunch", "flareblitz", "playrough", "superpower", "willowisp"],
		tier: "UU",
		doublesTier: "DOU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		randomBattleMoves: ["brickbreak", "bulkup", "earthquake", "icepunch", "superpower", "waterfall"],
		tier: "OU",
		doublesTier: "DOU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NFE",
	},
	alakazam: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	alakazammega: {
		randomBattleMoves: ["calmmind", "dazzlinggleam", "psychic", "recover", "shadowball"],
		tier: "OU",
		doublesTier: "DOU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		randomBattleMoves: ["brickbreak", "bulkup", "earthquake", "icepunch", "rockslide", "superpower"],
		tier: "UU",
		doublesTier: "DOU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		randomBattleMoves: ["poisonjab", "powerwhip", "sleeppowder", "suckerpunch", "swordsdance"],
		tier: "UU",
		doublesTier: "DOU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		randomBattleMoves: ["haze", "icebeam", "scald", "sludgebomb"],
		tier: "UU",
		doublesTier: "DOU",
	},
	geodude: {
		tier: "LC",
	},
	geodudealola: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	graveleralola: {
		tier: "NFE",
	},
	golem: {
		randomBattleMoves: ["earthquake", "explosion", "rockslide", "stealthrock", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	golemalola: {
		randomBattleMoves: ["earthquake", "explosion", "rockslide", "stealthrock", "thunderpunch"],
		tier: "UU",
		doublesTier: "DOU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		randomBattleMoves: ["drillrun", "flareblitz", "irontail", "megahorn", "willowisp"],
		tier: "UU",
		doublesTier: "DOU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "UU",
		doublesTier: "DOU",
	},
	slowbromega: {
		randomBattleMoves: ["calmmind", "icebeam", "psychic", "scald", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		randomBattleMoves: ["flashcannon", "lightscreen", "reflect", "thunderbolt", "thunderwave"],
		tier: "UU",
		doublesTier: "DOU",
	},
	farfetchd: {
		randomBattleMoves: ["fly", "poisonjab", "quickattack", "razorleaf", "swordsdance"],
		tier: "UU",
		doublesTier: "DOU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		randomBattleMoves: ["drillpeck", "jumpkick", "quickattack", "roost", "swordsdance"],
		tier: "UU",
		doublesTier: "DOU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		randomBattleMoves: ["aquajet", "icebeam", "iceshard", "megahorn", "surf"],
		tier: "UU",
		doublesTier: "DOU",
	},
	grimer: {
		tier: "LC",
	},
	grimeralola: {
		tier: "LC",
	},
	muk: {
		randomBattleMoves: ["brickbreak", "firepunch", "poisonjab", "protect", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	mukalola: {
		randomBattleMoves: ["crunch", "firepunch", "megadrain", "poisonjab", "toxic"],
		tier: "OU",
		doublesTier: "DOU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		randomBattleMoves: ["hydropump", "icebeam", "iceshard", "shellsmash", "surf"],
		tier: "OU",
		doublesTier: "DOU",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NFE",
	},
	gengar: {
		tier: "OU",
		doublesTier: "DOU",
	},
	gengarmega: {
		randomBattleMoves: ["dazzlinggleam", "shadowball", "sludgebomb", "substitute", "thunderbolt", "willowisp"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	onix: {
		randomBattleMoves: ["dragontail", "earthquake", "rockslide", "stealthrock", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		randomBattleMoves: ["calmmind", "dazzlinggleam", "psychic", "shadowball", "thunderwave"],
		tier: "UU",
		doublesTier: "DOU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		randomBattleMoves: ["agility", "crabhammer", "rockslide", "superpower", "xscissor"],
		tier: "UU",
		doublesTier: "DOU",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		randomBattleMoves: ["explosion", "lightscreen", "reflect", "taunt", "thunderbolt", "thunderwave"],
		tier: "UU",
		doublesTier: "DOU",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		randomBattleMoves: ["leechseed", "megadrain", "psychic", "sleeppowder", "sludgebomb"],
		tier: "UU",
		doublesTier: "DOU",
	},
	exeggutoralola: {
		randomBattleMoves: ["dragonpulse", "earthquake", "flamethrower", "megadrain", "stunspore"],
		tier: "OU",
		doublesTier: "DOU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		randomBattleMoves: ["bonemerang", "doubleedge", "earthquake", "rockslide", "stealthrock", "swordsdance"],
		tier: "UU",
		doublesTier: "DOU",
	},
	marowakalola: {
		randomBattleMoves: ["bonemerang", "earthquake", "flareblitz", "rockslide", "stealthrock", "swordsdance", "willowisp"],
		tier: "UU",
		doublesTier: "DOU",
	},
	hitmonlee: {
		randomBattleMoves: ["bulkup", "earthquake", "highjumpkick", "poisonjab", "rockslide"],
		tier: "UU",
		doublesTier: "DOU",
	},
	hitmonchan: {
		randomBattleMoves: ["brickbreak", "bulkup", "earthquake", "firepunch", "icepunch", "thunderpunch"],
		tier: "UU",
		doublesTier: "DOU",
	},
	lickitung: {
		randomBattleMoves: ["facade", "fireblast", "icebeam", "shadowball", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		randomBattleMoves: ["explosion", "fireblast", "flamethrower", "sludgebomb", "toxic", "willowisp"],
		tier: "UU",
		doublesTier: "DOU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		randomBattleMoves: ["earthquake", "megahorn", "rockslide", "stealthrock", "toxic"],
		tier: "OU",
		doublesTier: "DOU",
	},
	chansey: {
		randomBattleMoves: ["seismictoss", "softboiled", "stealthrock", "teleport", "toxic"],
		tier: "OU",
		doublesTier: "DOU",
	},
	tangela: {
		randomBattleMoves: ["leechseed", "megadrain", "protect", "sleeppowder", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	kangaskhan: {
		tier: "UU",
		doublesTier: "DOU",
	},
	kangaskhanmega: {
		randomBattleMoves: ["brickbreak", "earthquake", "facade", "fakeout", "suckerpunch"],
		tier: "UU",
		doublesTier: "DOU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		randomBattleMoves: ["agility", "dragonpulse", "hydropump", "icebeam", "scald", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		randomBattleMoves: ["drillrun", "icebeam", "megahorn", "poisonjab", "scald"],
		tier: "UU",
		doublesTier: "DOU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		randomBattleMoves: ["hydropump", "icebeam", "psychic", "recover", "scald", "thunderbolt"],
		tier: "OU",
		doublesTier: "DOU",
	},
	mrmime: {
		randomBattleMoves: ["calmmind", "dazzlinggleam", "encore", "psychic", "shadowball"],
		tier: "UU",
		doublesTier: "DOU",
	},
	scyther: {
		randomBattleMoves: ["brickbreak", "swordsdance", "uturn", "wingattack", "xscissor"],
		tier: "UU",
		doublesTier: "DOU",
	},
	jynx: {
		randomBattleMoves: ["calmmind", "icebeam", "lovelykiss", "psychic", "shadowball"],
		tier: "UU",
		doublesTier: "DOU",
	},
	electabuzz: {
		randomBattleMoves: ["brickbreak", "icepunch", "psychic", "thunderbolt", "thunderwave"],
		tier: "UU",
		doublesTier: "DOU",
	},
	magmar: {
		randomBattleMoves: ["clearsmog", "fireblast", "flamethrower", "psychic", "thunderpunch", "willowisp"],
		tier: "UU",
		doublesTier: "DOU",
	},
	pinsir: {
		tier: "UU",
		doublesTier: "DOU",
	},
	pinsirmega: {
		randomBattleMoves: ["earthquake", "rockslide", "superpower", "swordsdance", "xscissor"],
		tier: "UU",
		doublesTier: "DOU",
	},
	tauros: {
		randomBattleMoves: ["doubleedge", "earthquake", "fireblast", "rockslide", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "UU",
		doublesTier: "DOU",
	},
	gyaradosmega: {
		randomBattleMoves: ["crunch", "earthquake", "substitute", "thunderwave", "waterfall"],
		tier: "OU",
		doublesTier: "DOU",
	},
	lapras: {
		randomBattleMoves: ["hydropump", "icebeam", "surf", "thunderbolt", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	ditto: {
		randomBattleMoves: ["transform"],
		tier: "UU",
		doublesTier: "DOU",
	},
	eevee: {
		tier: "LC",
	},
	eeveestarter: {
		randomBattleMoves: ["bouncybubble", "buzzybuzz", "protect", "sappyseed", "sizzlyslide", "sparklyswirl"],
		isNonstandard: null,
		tier: "UU",
		doublesTier: "DOU",
	},
	vaporeon: {
		randomBattleMoves: ["icebeam", "protect", "rest", "scald", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	jolteon: {
		randomBattleMoves: ["shadowball", "substitute", "thunderbolt", "thunderwave", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	flareon: {
		randomBattleMoves: ["flareblitz", "irontail", "quickattack", "superpower", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	porygon: {
		randomBattleMoves: ["icebeam", "psychic", "recover", "toxic", "triattack"],
		tier: "UU",
		doublesTier: "DOU",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		randomBattleMoves: ["hydropump", "icebeam", "rockslide", "scald", "shellsmash"],
		tier: "UU",
		doublesTier: "DOU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		randomBattleMoves: ["aquajet", "rockslide", "stealthrock", "superpower", "swordsdance", "waterfall"],
		tier: "UU",
		doublesTier: "DOU",
	},
	aerodactyl: {
		tier: "OU",
		doublesTier: "DOU",
	},
	aerodactylmega: {
		randomBattleMoves: ["crunch", "earthquake", "rockslide", "roost", "stealthrock", "taunt"],
		tier: "OU",
		doublesTier: "DOU",
	},
	snorlax: {
		randomBattleMoves: ["bodyslam", "crunch", "earthquake", "rest", "toxic"],
		tier: "OU",
		doublesTier: "DOU",
	},
	articuno: {
		randomBattleMoves: ["icebeam", "roost", "substitute", "toxic", "uturn"],
		tier: "UU",
		doublesTier: "DOU",
	},
	zapdos: {
		randomBattleMoves: ["drillpeck", "roost", "thunderbolt", "toxic", "uturn"],
		tier: "OU",
		doublesTier: "DOU",
	},
	moltres: {
		randomBattleMoves: ["airslash", "fireblast", "flamethrower", "roost", "uturn", "willowisp"],
		tier: "UU",
		doublesTier: "DOU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		randomBattleMoves: ["agility", "earthquake", "fireblast", "outrage", "roost"],
		tier: "OU",
		doublesTier: "DOU",
	},
	mewtwo: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegax: {
		randomBattleMoves: ["brickbreak", "bulkup", "earthquake", "icepunch", "substitute"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegay: {
		randomBattleMoves: ["calmmind", "fireblast", "icebeam", "psychic", "recover", "shadowball"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	mew: {
		randomBattleMoves: ["flamethrower", "nastyplot", "psychic", "roost", "stealthrock", "willowisp"],
		tier: "OU",
		doublesTier: "DOU",
	},
	meltan: {
		randomBattleMoves: ["flashcannon", "protect", "thunderbolt", "toxic"],
		isNonstandard: null,
		tier: "UU",
		doublesTier: "DOU",
	},
	melmetal: {
		randomBattleMoves: ["doubleironbash", "earthquake", "icepunch", "rockslide", "thunderwave"],
		isNonstandard: null,
		tier: "OU",
		doublesTier: "DOU",
	},
};
